<template>
    <div style="display: flex;justify-content: space-between;">
        <img src="../assets/6.gif" class="box-shadow-class-left"
            style="width: 300px;margin-right:20px;border-radius: 20px;" alt="">
        <div>
            <!-- 关于我们-->
            <div class="box-shadow-class-left" style="text-align: center;
            background-color: #0c1433;border-radius: 10px;padding:30px 20px;font-size: 24px;font-weight: 600;">
                {{ $t('common.AboutUs') }}
            </div>
            <div class="box-shadow-class-right"
                style="background-color: #0c1433;padding: 20px;border-radius: 10px; min-height: 300px;margin-top: 40px;">
                <p class="about_me_p" v-for="(item, i) in company" :key="i">{{ item.title }}： {{ item.content }}</p>
            </div>

        </div>
    </div>

</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            company: [
                { title: this.$t('common.title3'), content: this.$t('common.content3') },
                { title: this.$t('common.title4'), content: this.$t('common.content4') },
                { title: this.$t('common.title5'), content: this.$t('common.content5') },
                { title: this.$t('common.title6'), content: this.$t('common.content6') },
            ],
        }
    },
}
</script>

<style scoped>
.box-shadow-class-right {
    box-shadow: 10px 10px 0px #409eff;
    border: 3px solid #666;
    box-sizing: border-box;
}

.box-shadow-class-left {
    box-shadow: -10px 10px 0px #409eff;
    border: 3px solid #666;
    box-sizing: border-box;
}

.border_parent {
    width: 90%;
    margin: auto;
}

.slider_img {
    height: 550px;
    width: 100%;
}

.solve {
    margin-top: 30px;
    margin-bottom: 10px
}

.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    height: auto;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.product_mobile_content {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product_mobile_img {
    width: 50%;
}

.product_mobile_title {
    font-weight: bold;
    text-align: center;
}

.product_pc_one {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.font_size_30 {
    font-size: 1.875em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    width: 100%
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    margin: 20px auto;
    background: #F2F6FC;
    align-items: center;
}

.product_spec_title {
    margin-top: 30px;
    margin-bottom: 10px
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.cooperation_parent {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    float: left;
    width: 25%;
    height: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    padding: 0 20px;
    margin: 10px;
}

.border_title {
    font-family: "PingFang SC";
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
}

.border_content_one {
    margin-top: 20px;
    font-size: 1.125em;
    text-align: center;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    height: 70px;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    text-align: center;
}

.border_spec_inner_last {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
    text-align: center;
}

.cooperation {
    margin-top: 30px;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    background: #F2F6FC;
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
    text-align: center;
}

.product_mobile_content_two {
    margin-top: 10px;
    text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }


    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;

    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: auto;
        background: #F2F6FC;
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .product_mobile_content_one {
        margin-top: 5px;
    }

    .product_mobile_content_two {
        margin-top: 5px;
    }

    .product_mobile_img_div {
        display: flex;
        width: 100%;
        height: auto;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .product_mobile_img {
        float: left;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 100%;
        margin-top: 15px;
    }

    .font_size_30 {
        font-size: 1.25em;
    }

    .product_font_style {
        font-size: 1em;
    }

    .product_pc_img {
        height: 280px;
        width: 320px;
    }

    .product_pc_img_div {
        width: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: auto;
        margin: 20px auto;
        background: #F2F6FC;
        flex-direction: column;
    }

    .head-label {
        display: flex;
        margin-top: 10px;
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
    }

    .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }


    .border_title {
        font-family: "PingFang SC";
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        /*background-color: aqua;*/
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
    }

    .border_spec_inner_last {
        /*background-color: bisque;*/
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
    }

    .about_me {
        display: flex;
        margin-top: 10px;
        width: 100%;
    }
}

.border_spec_img {
    width: 75px;
    height: 55px;
    align-self: center
}

.font_size_24 {
    font-size: 1.5em;
}
</style>